(function() {
    'use strict';
    
a3_cabin_reports.factory('FlightGateFactory',FlightGateFactory);
    /**
    * @memberof CabinReports
    * @ngdoc factory
    * @name FlightGateFactory
    * @description 
    *   Add, Update, Delete and Get Flight Gates.
    * @ngInject
    */ 
function FlightGateFactory(GenericService){
        
        /**
        * Initialize the FlightGate
        * @memberof FlightGateFactory
        */
		function FlightGate() {
			this.FlightDate = null;
			this.Codeshares = [];
			this.FlightNo = null;
			this.Departure = null;
			this.Arrival = null;
			this.STD = null;
			this.STA = null;
			this.ETD = null;
			this.ETA = null;
			this.STD_Diff = null;
			this.STA_Diff = null;
			this.STD_lcl = null;
			this.STA_lcl = null;
			this.ETD_lcl = null;
			this.ETA_lcl = null;
			this.DepGate = null;
			this.DepStand = null;
			this.AcType = null;
			this.lastUpdate = null;
			//net fields used to hold values before latest update
			this.previousUpdate = null;
			this.previousGate = null;
			this.previousSTD = null;
			this.previousSTD_lcl = null;
			this.previousSTD_Diff = null;
			this.previousSTA = null;
			this.previousSTA_lcl = null;
			this.previousSTA_Diff = null;
			//object functions
			this.getRoute=getRoute;
			this.dtSTD=dtSTD
			this.dtSTA=dtSTA;
			this.dtETD=dtETD;
			this.dtETA=dtETA;
			this.dtSTD_lcl=dtSTD_lcl;
			this.dtSTA_lcl=dtSTA_lcl;
			this.dtETD_lcl=dtETD_lcl;
			this.dtETA_lcl=dtETA_lcl;
			this.dateSTD=dateSTD;
			this.timeSTD=timeSTD;
			this.timeSTA=timeSTA;
			this.timeETD=timeETD;
			this.timeETA=timeETA;
			this.timeSTD_lcl=timeSTD_lcl;
			this.timeSTA_lcl=timeSTA_lcl;
			this.timeETD_lcl=timeETD_lcl;
			this.timeETA_lcl=timeETA_lcl;
			this.hasETD=hasETD;
			this.hasETA=hasETA;
			this.depDelay=depDelay;
			this.arrDelay=arrDelay;
			this.setUpdatedNow=setUpdatedNow;
			this.gateChanged=gateChanged;
			this.stdChanged=stdChanged;
			this.staChanged=staChanged;
			this.stdDiffChanged=stdDiffChanged;
			this.staDiffChanged=staDiffChanged;
			this.toString=toString;
			this.changesToString=changesToString;
			this.getKey=getKey;
		}
			 
		var objType = 'FlightGates';
		var objCallback = FlightGate;  
				
		var service = {
			processUpdatedData : processUpdatedData,
			getFromStorage : getFromStorage,
			getAfterSTDFromStorage : getAfterSTDFromStorage,
			setToStorage : setToStorage
		}
		
		//Object functions
		function getRoute() {
			if (this.Departure == null && this.Arrival == null) return '-null-';
			else return (this.Departure || '?') + '-' + (this.Arrival || '?');
		}
				
        /**
        * Transform STD iso string to datetime
        * @memberof FlightGateFactory
        * @return {object} date
        */
		function dtSTD(){
			return stringIsoToDateTime(this.STD);
		}
			
        /**
        * Transform STA iso string to datetime
        * @memberof FlightGateFactory
        * @return {object} date
        */
		function dtSTA(){
			return stringIsoToDateTime(this.STA);
		}

        /**
        * Transform ETD iso string to datetime
        * @memberof FlightGateFactory
        * @return {object} date
        */
		function dtETD(){
			return stringIsoToDateTime(this.ETD);
		}
        /**
        * Transform ETA iso string to date
        * @memberof FlightGateFactory
        * @return {object} date
        */
		function dtETA(){
			return stringIsoToDateTime(this.ETA);
		}			
        /**
        * Transform local STD iso string to datetime
        * @memberof FlightGateFactory
        * @return {object} date
        */		
		function dtSTD_lcl(){
			return stringIsoToDateTime(this.STD_lcl);
		}
        /**
        * Transform local STA iso string to datetime
        * @memberof FlightGateFactory
        * @return {object} date
        */	
		function dtSTA_lcl(){
			return stringIsoToDateTime(this.STA_lcl);
		}
        /**
        * Transform local ETD iso string to datetime
        * @memberof FlightGateFactory
        * @return {object} date
        */
		function dtETD_lcl(){
			return stringIsoToDateTime(this.ETD_lcl);
		}
        /**
        * Transform local ETA iso string to datetime
        * @memberof FlightGateFactory
        * @return {object} date
        */
		function dtETA_lcl(){
			return stringIsoToDateTime(this.ETA_lcl);
		}	
        /**
        * Transform STD iso string to date string
        * @memberof FlightGateFactory
        * @return {string} date
        */
        function dateSTD(){
			return stringIsoToDateString(this.STD);
		}
        /**
        * Transform STD iso string to time string 
        * @memberof FlightGateFactory
        * @return {string} time
        */
		function timeSTD(){
			return stringIsoToTimeString(this.STD);
		}
        /**
        * Transform STA iso string to time string 
        * @memberof FlightGateFactory
        * @return {string} time
        */
		function timeSTA(){
			return stringIsoToTimeString(this.STA);
		}
        /**
        * Transform ETD iso string to time string
        * @memberof FlightGateFactory
        * @return {object} time
        */
		function timeETD(){
			return stringIsoToTimeString(this.ETD);
		}
        /**
        * Transform ETA iso string to time string
        * @memberof FlightGateFactory
        * @return {string} time
        */
		function timeETA(){
			return stringIsoToTimeString(this.ETA);
		}
        /**
        * Transform STD iso string to local time string
        * @memberof FlightGateFactory
        * @return {string} time
        */
		function timeSTD_lcl(){
			return stringIsoToTimeString(this.STD_lcl);
		}
        /**
        * Transform local STA iso string to string time
        * @memberof FlightGateFactory
        * @return {string} time
        */
		function timeSTA_lcl(){
			return stringIsoToTimeString(this.STA_lcl);
		}
        /**
        * Transform local ETD iso string to time string
        * @memberof FlightGateFactory
        * @return {string} time
        */
		function timeETD_lcl(){
			return stringIsoToTimeString(this.ETD_lcl);
		}
        /**
        * Transform local ETA iso string to time
        * @memberof FlightGateFactory
        * @return {string} time
        */
		function timeETA_lcl(){
			return stringIsoToTimeString(this.ETA_lcl);
		}

        /**
        * check if gate has ETD
        * @memberof FlightGateFactory
        * @return {boolean} hasETD
        */
		function hasETD(){
			if (this.ETD && this.STD != this.ETD && this.dtSTD() < this.dtETD())
				return true;
			else
				return false;
		}

        /**
        * check if gate has ETA
        * @memberof FlightGateFactory
        * @return {boolean} hasETA
        */
		function hasETA(){
			return (this.ETA && this.STA != this.ETA && this.dtSTA() < this.dtETA())
		}

        /**
        * Return departure delay
        * @memberof FlightGateFactory
        * @return {string} STD_Diff
        */
		function depDelay(){
			if (this.hasETD() && this.STD_Diff && this.STD_Diff > 0)
				return this.STD_Diff;
			else
				return null;
		}
    
        /**
        * Return arrival delay
        * @memberof FlightGateFactory
        * @return {boolean} STA_Diff
        */
		function arrDelay(){
			if (this.hasETA() && this.STA_Diff && this.STA_Diff > 0)
				return this.STA_Diff;
			else
				return null;
		}

         /**
        * record the current time as the lastUpdate of the object
        * @memberof FlightGateFactory
        */
		function setUpdatedNow(){
			this.lastUpdate = new Date();
			if (this.DepGate == null)
				this.DepGate='';
		}

        /**
        * Check if the gate has changed since the last update
        * @memberof FlightGateFactory
        * @return {boolean} gateChanged
        */
		function gateChanged(){
			if (!this.previousGate)
				return false;
			else
				return true;
		}

        /**
        * Check if the STD has changed since the last update
        * @memberof FlightGateFactory
        * @return {boolean} stdChanged
        */
		function stdChanged(){
			if (!this.previousSTD)
				return false;
			else
				return true;
		}

        /**
        * Check if the STA has changed since the last update
        * @memberof FlightGateFactory
        * @return {boolean} staChanged
        */
		function staChanged(){
			if (!this.previousSTA)
				return false;
			else
				return true;
		}

        /**
        * Check if the STD diff has changed since the last update
        * @memberof FlightGateFactory
        * @return {boolean} stdDiffChanged
        */
		function stdDiffChanged(){
			if (!this.previousSTD_Diff)
				return false;
			else
				return true;
		}

        /**
        * Check if the STA diff has changed since the last update
        * @memberof FlightGateFactory
        * @return {boolean} staDiffChanged
        */
		function staDiffChanged(){
			if (!this.previousSTA_Diff)
				return false;
			else
				return true;
		}

        /**
        * Print the flight gate info
        * @memberof FlightGateFactory
        * @return {string} toSting
        */ 
		function toString(){
			var s=this.dateSTD() + ' ' + this.FlightNo;
			s+=' ' + this.Departure + '-' + this.Arrival;
			s+=' ' + (this.hasETD() ? 'ETD'+this.timeETD_lcl()+(this.depDelay() ? '[+'+this.depDelay()+'\']' : '') : 'STD'+this.timeSTD_lcl());
			s+='->' + (this.hasETA() ? 'ETA'+this.timeETA_lcl() + '[' + (this.STA_Diff>0 ? '+' : '-')+this.STA_Diff + '\']' : 'STA'+this.timeSTA_lcl());
			s+=(this.DepGate ? ' Gate: ' + this.DepGate : '');
			return s;
		}
    
        /**
        * Show all the changes of  the flight gates
        * @memberof FlightGateFactory
        * @return {string} toSting
        */ 
		function changesToString(){
			var s='';
			if (this.stdChanged())
				s+='STD: ' + stringIsoToTimeString(this.previousSTD) + ' -> ' + this.timeSTD();
			if (self.stdDiffChanged())
				s+=(s=='' ? '' : ', ')+'departure delay: '+this.previousSTD_Diff + ' -> ' + this.STD_Diff;
			if (self.staChanged())
				s+=(s=='' ? '' : ', ')+'STA: ' + stringIsoToTimeString(this.previousSTA) + ' -> ' + this.timeSTA();
			if (self.staDiffChanged())
				s+=(s=='' ? '' : ', ')+'arrival delay: '+this.previousSTA_Diff + ' -> ' + this.STA_Diff;
			if (self.gateChanged())
				s+=(s=='' ? '' : ', ')+' gate: '+this.previousGate + ' -> ' + this.DepGate;
			return s;
		}

        /**
        * returns a string with all the fields uniquely defining a flight, concatenated
        * @memberof FlightGateFactory
        * @return {string} key
        */ 
		function getKey(){
			var s = this.FlightDate + '|' + this.FlightNo + '|' + this.Departure + '-' + this.Arrival;
			return s;
		}
		
        //Service functions
        /**
        * Transform iso datetime string to date time Object
        * @memberof FlightGateFactory
        * @return {Object} DateTime
        */
		function stringIsoToDateTime(str){
			var dt=null;
			try{
				if (str){
					//replace T in order to avoid browser converting datetime to browser's timezone
					//eg 2016-05-17T23:04:00 would be converted to Wed May 18 2016 02:04:00 GMT+0300 (GTB Daylight Time) when we want it to be Tue May 17 2016 23:04:00 GMT+0300 (GTB Daylight Time)
					str = str.replace('T', ' ');
					dt=new Date(str);
				}
			}
			catch(e){}
			return dt;
		}
        /**
        * Transform iso datetime string to date string
        * @memberof FlightGateFactory
        * @return {string} date
        */
		function stringIsoToDateString(str){
			var dt= stringIsoToDateTime(str);
			var s=null;
			if (dt){
				var year=dt.getFullYear();
				var month=dt.getMonth()+1;
				var day=dt.getDate();
				s=(day < 10 ? '0' : '')+day+'.'+(month < 10 ? '0' : '')+month+'.'+year;
			}
			return s;
		}
        /**
        * Transform iso datetime string to time string
        * @memberof FlightGateFactory
        * @return {string} time
        */
		function stringIsoToTimeString(str){
			var dt=stringIsoToDateTime(str);
			var s=null;
			if (dt){
				var hour=dt.getHours();
				var min=dt.getMinutes();
				s=(hour < 10 ? '0' : '')+hour+':'+(min<10 ? '0' : '')+min+'';
			}
			return s;
		}
		
        /**
        * Process updated list of fligths 'gates' and store them.Before storing them, we need to identify changes in Gates and in ETD/ETA to notify customers when required. 
        * @memberof FlightGateFactory
        */
		function processUpdatedData(data){
			//Update List
			var list= fromObjectList(data);
			
			//Original List
			var listPrevious=getFromStorage();
			
			//Search each "new" flight in the new list, and check if it has been modified since last update
			if (list && list.length > 0)
			{
				var flight,flightPrevious, hasChanged;
				var previousLength=listPrevious.length;
				for(var i=0;i<list.length;i++){
					flight=list[i];
					//mark that this flight was updated now
					flight.setUpdatedNow();
					//check for flight in previous list, and if found, check for changes
					if (listPrevious && previousLength>0){
						for(var p=0;p<previousLength;p++){
							flightPrevious = listPrevious[p];
							if (flight.getKey() === flightPrevious.getKey()){
								hasChanged=false;
								if (flight.DepGate != flightPrevious.DepGate)
								{
									hasChanged=true;
									flight.previousGate = flightPrevious.DepGate;
								}
								if (flight.STD != flightPrevious.STD)
								{
									hasChanged=true;
									flight.previousSTD = flightPrevious.STD;
									flight.previousSTD_lcl = flightPrevious.STD_lcl;
								}
								if (flight.STA != flightPrevious.STA)
								{
									hasChanged=true;
									flight.previousSTA = flightPrevious.STA;
									flight.previousSTA_lcl = flightPrevious.STA_lcl;
								}
								if (flight.STD_Diff != flightPrevious.STD_Diff)
								{
									hasChanged=true;
									flight.previousSTD_Diff = flightPrevious.STD_Diff;
								}
								if (flight.STA_Diff != flightPrevious.STA_Diff)
								{
									hasChanged=true;
									flight.previousSTA_Diff = flightPrevious.STA_Diff;
								}
								if (hasChanged)
								{
									flight.previousUpdate=flightPrevious.lastUpdate;
								}
								break;
							}
						}
					}
				}
			}
			
			setToStorage(list);
		}

        /**
        * Get flightgates from storage
        * @memberof FlightGateFactory
        * @return {array} flightgates
        */
		function getFromStorage() {
			return GenericService.list(objType,objCallback);
		}

        /**
        * Get flightgates after std and flight gates selected departure
        * @memberof FlightGateFactory
        * @param {string} std  STD iso datetime string   
        * @param {string} dep  Departure
        * @return {array} flightgates
        */
		function getAfterSTDFromStorage(std,dep) {
			var newFlightgates = [];
			var now_utc = new Date(std);
			var date = now_utc.getTime();
			var flightgates = getFromStorage();
			for(var i = 0 ; i<flightgates.length ; i++){
				var dateSTD = new Date(flightgates[i].STD);
				var dateETD = null;
				if(dateETD) {
					dateETD=new Date(flightgates[i].ETD);
				}
				if((dateSTD.getTime()>=date || (dateETD !=null && dateETD.getTime()>=date )) && dep==flightgates[i].Departure && 
					//check only for 2 days later
					(dateSTD.getTime()<=(date+172800000))) {
					newFlightgates.push(flightgates[i]);
				}
			}
			return newFlightgates;
		}
    
        /**
        * Set flightgates from storage
        * @memberof FlightGateFactory
        * @param {array} data
        */	
		function setToStorage(data){
			GenericService.saveAll(data,objType,objCallback);
		}
		
        /**
         * Extend an array of Objects from the default FlightGate Object
         * @memberof FlightGateFactory
         * @param {Array} objList  an Array Of FlightGates
         * @returns {Array} FlightGates
         */
		function fromObjectList( objList ) {
			if (!objList)
				return [];

			var arrayLength = objList.length;
			var result = [];

			for (var i = 0; i < arrayLength; i++) {
				var item = new FlightGate();
				angular.extend(item, objList[i]);

				result.push(item);
			}

			return result;
		}

		return service;
	}

})();